import React, { useState, useRef, lazy } from 'react';
import { Heart, MessageCircle, Share2, Bookmark, MoreHorizontal, Lock, Gift, MapPin, ChevronLeft, Bell, BellOff, CheckCircle, Flame, ArrowLeft, ShoppingBag, Image as ImageIcon, Mic, Flag, Target, Music, Award, DollarSign, Send, ChevronRight, Video, Sparkles, X } from 'lucide-react';
import { VideoGenerationUpsell } from './VideoGenerationUpsell';
interface KimHollandAngelFeedProps {
  onBack: () => void;
}
export const KimHollandAngelFeed: React.FC<KimHollandAngelFeedProps> = ({
  onBack
}) => {
  const [activeTab, setActiveTab] = useState('all');
  const [isFollowing, setIsFollowing] = useState(false);
  const [likedPosts, setLikedPosts] = useState<Record<string, boolean>>({});
  const [showNotificationOptions, setShowNotificationOptions] = useState(false);
  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const [showPollResults, setShowPollResults] = useState(false);
  const [pollVote, setPollVote] = useState<string | null>(null);
  const [commentText, setCommentText] = useState('');
  const [showUnlockModal, setShowUnlockModal] = useState(false);
  const [unlockPostId, setUnlockPostId] = useState<string | null>(null);
  const [showImageGeneratorModal, setShowImageGeneratorModal] = useState(false);
  const [showVideoUpsellModal, setShowVideoUpsellModal] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);
  const tabs = [{
    id: 'all',
    label: 'All',
    icon: <Flame size={14} data-id="element-8763" />
  }, {
    id: 'media',
    label: 'Media',
    icon: <ImageIcon size={14} data-id="element-8764" />
  }, {
    id: 'voice',
    label: 'Voice',
    icon: <Mic size={14} data-id="element-8765" />
  }, {
    id: 'missions',
    label: 'Missions',
    icon: <Target size={14} data-id="element-8766" />
  }, {
    id: 'polls',
    label: 'Polls',
    icon: <Flag size={14} data-id="element-8767" />
  }, {
    id: 'upsells',
    label: 'Upsells',
    icon: <Lock size={14} data-id="element-8768" />
  }, {
    id: 'shop',
    label: 'Shop',
    icon: <ShoppingBag size={14} data-id="element-8769" />
  }];
  const scrollTabs = (direction: 'left' | 'right') => {
    if (tabsRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      tabsRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const toggleFollow = () => {
    setIsFollowing(!isFollowing);
  };
  const toggleNotification = () => {
    setNotificationEnabled(!notificationEnabled);
    setShowNotificationOptions(false);
  };
  const toggleLike = (postId: string) => {
    setLikedPosts(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };
  const handlePollVote = (option: string) => {
    setPollVote(option);
    setShowPollResults(true);
  };
  const handleUnlock = (postId: string) => {
    setUnlockPostId(postId);
    setShowUnlockModal(true);
  };
  const confirmUnlock = () => {
    // Here you would handle the actual token transaction
    setShowUnlockModal(false);
  };
  const posts = [{
    id: 'post1',
    type: 'premium_content',
    content: "Just got out of the shower... want to see what's underneath this towel? 💦 Unlock for a steamy surprise...",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    likes: 4562,
    comments: 387,
    time: '2h ago',
    locked: true,
    price: 7,
    location: 'My Bathroom',
    hashtags: ['#shower', '#steamy', '#exclusive', '#towel']
  }, {
    id: 'post2',
    type: 'poll',
    content: "What should I wear for tomorrow's livestream? I want to look my best for you... 💕",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    likes: 2156,
    comments: 289,
    time: '5h ago',
    location: 'My Closet',
    poll: {
      options: [{
        text: 'Red lingerie set 👙',
        percentage: 70
      }, {
        text: 'Casual jeans & tight top 👚',
        percentage: 30
      }],
      endsIn: '4 hours'
    },
    hashtags: ['#livestream', '#outfit', '#fashion', '#voteplease']
  }, {
    id: 'post3',
    type: 'voice_note',
    content: "Here's a little preview of what you'll hear in our private call later... 🎧 Listen closely...",
    likes: 3421,
    comments: 412,
    time: '1d ago',
    location: 'My Bedroom',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    duration: '0:35',
    hashtags: ['#voice', '#whisper', '#asmr', '#preview']
  }];
  const filteredPosts = posts.filter(post => {
    if (activeTab === 'all') return true;
    if (activeTab === 'media' && (post.type === 'image' || post.type === 'premium_content')) return true;
    if (activeTab === 'voice' && post.type === 'voice_note') return true;
    if (activeTab === 'polls' && post.type === 'poll') return true;
    if (activeTab === 'upsells' && post.type === 'premium_content') return true;
    return false;
  });
  return <section className="w-full max-w-[860px] mx-auto px-4 space-y-4 angel-feed-container" data-id="element-8770">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white/90 dark:bg-gray-950/90 backdrop-blur-sm p-3 flex items-center justify-between border-b border-gray-200 dark:border-gray-800" data-id="element-8771">
        <div className="flex items-center gap-4" data-id="element-8772">
          <button className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => {
          // Navigate back to AllAngelsGrid
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'all_angels'
            }
          });
          document.dispatchEvent(navigateEvent);
          onBack(); // Still call onBack to clean up any state
        }} data-id="element-8773">
            <ArrowLeft size={20} className="text-gray-700 dark:text-gray-300" data-id="element-8774" />
          </button>
          <div data-id="element-8775">
            <h1 className="font-bold text-lg text-gray-900 dark:text-white" data-id="element-8776">
              Kim Holland
            </h1>
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8777">
              1.2M Followers
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-8778">
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-gray-800 dark:text-white text-xs font-medium" onClick={() => setShowImageGeneratorModal(true)} data-id="element-8779">
            <ImageIcon size={12} className="text-pink-400" data-id="element-8780" />
            <span data-id="element-8781">Generate Image</span>
          </button>
          <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-gray-800 dark:text-white text-xs font-medium" onClick={() => setShowVideoUpsellModal(true)} data-id="element-8782">
            <Video size={12} className="text-pink-400" data-id="element-8783" />
            <span data-id="element-8784">Generate Video</span>
          </button>
          <div className="relative" data-id="element-8785">
            <button className="p-2 bg-gray-100 dark:bg-gray-800 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" onClick={() => setShowNotificationOptions(!showNotificationOptions)} data-id="element-8786">
              {notificationEnabled ? <Bell size={20} className="text-pink-500 dark:text-pink-400" data-id="element-8787" /> : <BellOff size={20} className="text-gray-500 dark:text-gray-400" data-id="element-8788" />}
            </button>
            {showNotificationOptions && <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-800 z-10" data-id="element-8789">
                <button className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-t-lg flex items-center gap-2 text-gray-700 dark:text-gray-300" onClick={toggleNotification} data-id="element-8790">
                  {notificationEnabled ? <>
                      <BellOff size={16} data-id="element-8791" />
                      <span data-id="element-8792">Disable notifications</span>
                    </> : <>
                      <Bell size={16} data-id="element-8793" />
                      <span data-id="element-8794">Enable notifications</span>
                    </>}
                </button>
              </div>}
          </div>
          <button className={`px-4 py-1.5 rounded-full font-bold ${isFollowing ? 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white hover:bg-red-100 dark:hover:bg-red-900 hover:text-red-600 dark:hover:text-red-400' : 'bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:opacity-90'}`} onClick={toggleFollow} data-id="element-8795">
            {isFollowing ? 'Following' : 'Follow'}
          </button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-8796">
            <Sparkles size={16} className="text-pink-400" data-id="element-8797" />
          </button>
        </div>
      </div>

      {/* Profile Banner */}
      <div className="relative" data-id="element-8798">
        <div className="h-32 w-full bg-gradient-to-r from-pink-600 to-purple-600 rounded-t-xl" data-id="element-8799"></div>
        <div className="absolute -bottom-16 left-4 w-32 h-32 rounded-full border-4 border-white dark:border-gray-950 overflow-hidden" data-id="element-8800">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png" alt="Kim Holland" className="w-full h-full object-cover image-high-quality" loading="lazy" data-id="element-8801" />
        </div>
      </div>

      {/* Profile Info */}
      <div className="mt-20 px-4 ml-36" data-id="element-8802">
        <div className="flex items-center gap-1" data-id="element-8803">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-8804">
            Kim Holland
          </h2>
          <CheckCircle size={16} className="text-pink-400" fill="currentColor" data-id="element-8805" />
          <span className="text-sm font-normal text-pink-400 ml-2" data-id="element-8806">💋🔥</span>
        </div>
        <p className="text-gray-500 dark:text-gray-400" data-id="element-8807">@KimHolland</p>
        <p className="mt-2 text-gray-700 dark:text-gray-300" data-id="element-8808">
          Girl-next-door with a naughty secret 🤫 Let me show you my wild side
          when nobody's watching...
        </p>
        <div className="flex gap-4 mt-3 text-sm" data-id="element-8809">
          <div className="flex items-center gap-1" data-id="element-8810">
            <span className="font-bold text-gray-900 dark:text-white" data-id="element-8811">156</span>
            <span className="text-gray-500 dark:text-gray-400" data-id="element-8812">Following</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-8813">
            <span className="font-bold text-gray-900 dark:text-white" data-id="element-8814">
              1.2M
            </span>
            <span className="text-gray-500 dark:text-gray-400" data-id="element-8815">Followers</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-8816">
            <span className="font-bold text-gray-900 dark:text-white" data-id="element-8817">410</span>
            <span className="text-gray-500 dark:text-gray-400" data-id="element-8818">
              Intimacy XP
            </span>
          </div>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="mt-4 relative border-b border-gray-200 dark:border-gray-800" data-id="element-8819">
        <button className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 rounded-full text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300" onClick={() => scrollTabs('left')} data-id="element-8820">
          <ChevronLeft size={18} data-id="element-8821" />
        </button>
        <div ref={tabsRef} className="flex overflow-x-auto scrollbar-hide px-8 py-1" data-id="element-8822">
          {tabs.map(tab => <button key={tab.id} className={`px-4 py-2 flex items-center gap-1.5 whitespace-nowrap rounded-full mx-1 ${activeTab === tab.id ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800/50 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800'}`} onClick={() => setActiveTab(tab.id)} data-id="element-8823">
              {tab.icon}
              <span data-id="element-8824">{tab.label}</span>
            </button>)}
        </div>
        <button className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 rounded-full text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300" onClick={() => scrollTabs('right')} data-id="element-8825">
          <ChevronRight size={18} data-id="element-8826" />
        </button>
      </div>

      {/* Posts Feed */}
      <div className="space-y-4" data-id="element-8827">
        {filteredPosts.length > 0 ? filteredPosts.map(post => <div key={post.id} className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in fade-in duration-300 angel-feed-post shadow-md hover:shadow-xl hover:shadow-pink-600/5 transition-all duration-300" data-id="element-8828">
              {/* Post Header */}
              <div className="p-3 flex items-center gap-2 border-b border-gray-200 dark:border-gray-800" data-id="element-8829">
                <div className="w-10 h-10 rounded-full overflow-hidden" data-id="element-8830">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png" alt="Kim Holland" className="w-full h-full object-cover image-high-quality" loading="lazy" data-id="element-8831" />
                </div>
                <div data-id="element-8832">
                  <div className="flex items-center gap-1" data-id="element-8833">
                    <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-8834">
                      Kim Holland
                    </h3>
                    <CheckCircle size={14} className="text-pink-400" fill="currentColor" data-id="element-8835" />
                    <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8836">
                      • {post.time}
                    </span>
                  </div>
                  {post.location && <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-8837">
                      <MapPin size={10} className="ml-1" data-id="element-8838" />
                      <span data-id="element-8839">{post.location}</span>
                    </div>}
                </div>
                <button className="ml-auto" data-id="element-8840">
                  <MoreHorizontal size={16} className="text-gray-500 dark:text-gray-400" data-id="element-8841" />
                </button>
              </div>
              {/* Post Content */}
              <div className="px-3 py-2" data-id="element-8842">
                <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8843">
                  {post.content}
                </p>
                {/* Hashtags */}
                {post.hashtags && <div className="text-xs text-pink-400 mt-1" data-id="element-8844">
                    {post.hashtags.join(' ')}
                  </div>}
              </div>
              {/* Post Media */}
              {(post.type === 'image' || post.type === 'poll' && post.image) && post.image && <div className="aspect-square bg-gray-100 dark:bg-gray-800" data-id="element-8845">
                    <img src={post.image} alt="Post" className="w-full h-full object-cover angel-post-image hover:scale-[1.02] transition-transform duration-300" sizes="(max-width: 768px) 100vw, 820px" loading="lazy" data-id="element-8846" />
                  </div>}
              {/* Premium Content */}
              {post.type === 'premium_content' && post.image && <div className="relative aspect-square bg-gray-100 dark:bg-gray-800" data-id="element-8847">
                  <img src={post.image} alt="Locked Content" className="w-full h-full object-cover blur-sm angel-post-image" sizes="(max-width: 768px) 100vw, 820px" loading="lazy" data-id="element-8848" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-8849">
                    <Lock size={32} className="text-pink-400 mb-2" data-id="element-8850" />
                    <p className="text-center text-white font-medium" data-id="element-8851">
                      Unlock Exclusive Photo
                    </p>
                    <button className="mt-3 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium flex items-center gap-2 hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => handleUnlock(post.id)} data-id="element-8852">
                      <span data-id="element-8853">Unlock for</span>
                      <span className="text-pink-200" data-id="element-8854">{post.price} 💎</span>
                    </button>
                  </div>
                </div>}
              {/* Poll */}
              {post.type === 'poll' && post.poll && <div className="p-3" data-id="element-8855">
                  <div className="space-y-2" data-id="element-8856">
                    {post.poll.options.map((option, i) => <button key={i} className={`w-full p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border ${pollVote === option.text ? 'border-pink-500 dark:border-pink-400' : 'border-gray-200 dark:border-gray-700 hover:border-pink-500 dark:hover:border-pink-400'} transition flex justify-between items-center`} onClick={() => handlePollVote(option.text)} data-id="element-8857">
                        <span className="text-gray-700 dark:text-gray-300" data-id="element-8858">
                          {option.text}
                        </span>
                        {(showPollResults || pollVote) && <span className="text-xs bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full text-gray-700 dark:text-gray-300" data-id="element-8859">
                            {option.percentage}%
                          </span>}
                      </button>)}
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-2" data-id="element-8860">
                      Voting ends in {post.poll.endsIn} • Results will shape
                      tomorrow's stream
                    </p>
                  </div>
                </div>}
              {/* Voice Note */}
              {post.type === 'voice_note' && post.audioWaveform && <div className="p-3" data-id="element-8861">
                  <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-8862">
                    <div className="flex items-center gap-3" data-id="element-8863">
                      <button className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-8864">
                        <div className="ml-1" data-id="element-8865">▶</div>
                      </button>
                      <div className="flex-grow h-10 flex items-center" data-id="element-8866">
                        {post.audioWaveform.map((level, i) => <div key={i} className="w-1 mx-0.5 rounded-full bg-gradient-to-t from-pink-500/50 to-purple-500/50" style={{
                  height: `${level * 32}px`
                }} data-id="element-8867"></div>)}
                      </div>
                      <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-8868">
                        <span data-id="element-8869">{post.duration}</span>
                      </div>
                    </div>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-2" data-id="element-8870">
                      🎧 Best experienced with headphones
                    </p>
                  </div>
                </div>}
              {/* Post Actions */}
              <div className="p-3" data-id="element-8871">
                <div className="flex items-center justify-between" data-id="element-8872">
                  <div className="flex items-center gap-3" data-id="element-8873">
                    <button className="flex items-center gap-1 group" onClick={() => toggleLike(post.id)} data-id="element-8874">
                      <Heart size={18} className={likedPosts[post.id] ? 'text-pink-500' : 'text-gray-400 group-hover:text-pink-400'} fill={likedPosts[post.id] ? 'currentColor' : 'none'} data-id="element-8875" />
                      <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-8876">
                        {likedPosts[post.id] ? post.likes + 1 : post.likes}
                      </span>
                    </button>
                    <button className="flex items-center gap-1" data-id="element-8877">
                      <MessageCircle size={18} className="text-gray-400" data-id="element-8878" />
                      <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-8879">
                        {post.comments}
                      </span>
                    </button>
                    <button className="flex items-center gap-1" data-id="element-8880">
                      <Share2 size={18} className="text-gray-400" data-id="element-8881" />
                      <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-8882">
                        Share
                      </span>
                    </button>
                  </div>
                  <button className="flex items-center gap-1" data-id="element-8883">
                    <Gift size={18} className="text-pink-400" data-id="element-8884" />
                    <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-8885">
                      Gift
                    </span>
                  </button>
                </div>
                <div className="flex items-center gap-1 mt-2" data-id="element-8886">
                  <div className="flex -space-x-2" data-id="element-8887">
                    <div className="w-5 h-5 rounded-full border border-white dark:border-gray-900 bg-gray-200 dark:bg-gray-700" data-id="element-8888"></div>
                    <div className="w-5 h-5 rounded-full border border-white dark:border-gray-900 bg-gray-200 dark:bg-gray-700" data-id="element-8889"></div>
                  </div>
                  <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8890">
                    Liked by David and {(post.likes - 1).toLocaleString()}{' '}
                    others
                  </span>
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-8891">
                  View all {post.comments} comments
                </div>
              </div>
            </div>) : <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-8 text-center" data-id="element-8892">
            <div className="w-16 h-16 mx-auto flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full mb-4" data-id="element-8893">
              {activeTab === 'media' ? <ImageIcon size={24} className="text-gray-400 dark:text-gray-600" data-id="element-8894" /> : activeTab === 'voice' ? <Mic size={24} className="text-gray-400 dark:text-gray-600" data-id="element-8895" /> : <Heart size={24} className="text-gray-400 dark:text-gray-600" data-id="element-8896" />}
            </div>
            <h3 className="text-lg font-bold mb-2 text-gray-900 dark:text-white" data-id="element-8897">
              No {activeTab} content yet
            </h3>
            <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto" data-id="element-8898">
              Kim hasn't posted any {activeTab} content yet. Check back soon!
            </p>
          </div>}
      </div>

      {/* Mission Card */}
      <div className="bg-gradient-to-r from-pink-50/90 to-purple-50/90 dark:from-pink-900/30 dark:to-purple-900/30 rounded-xl border border-pink-100 dark:border-pink-800/50 p-4 shadow-md hover:shadow-xl hover:shadow-pink-600/5 transition-all duration-300" data-id="element-8899">
        <div className="flex items-center gap-3" data-id="element-8900">
          <div className="w-10 h-10 flex items-center justify-center bg-pink-100 dark:bg-pink-500/20 rounded-full text-pink-500 dark:text-pink-400" data-id="element-8901">
            🔥
          </div>
          <div data-id="element-8902">
            <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-8903">
              Daily Mission
            </h3>
            <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8904">
              Watch Kim's private stream
            </p>
          </div>
        </div>
        <div className="mt-3" data-id="element-8905">
          <div className="flex items-center justify-between mb-1" data-id="element-8906">
            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8907">
              Progress
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-8908">
              {Object.values(likedPosts).filter(Boolean).length}/3
            </span>
          </div>
          <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-8909">
            <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
            width: `${Math.min(Object.values(likedPosts).filter(Boolean).length / 3 * 100, 100)}%`
          }} data-id="element-8910"></div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-3" data-id="element-8911">
          <div className="flex items-center gap-1" data-id="element-8912">
            <span className="text-pink-500 dark:text-pink-400" data-id="element-8913">💗</span>
            <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8914">
              +30
            </span>
          </div>
          <button className="text-xs px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" data-id="element-8915">
            Join Stream
          </button>
        </div>
      </div>

      {/* Unlock Modal */}
      {showUnlockModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-8916">
          <div className="w-full max-w-sm bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300 shadow-2xl" data-id="element-8917">
            <div className="p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-8918">
              <h3 className="font-bold text-gray-900 dark:text-white" data-id="element-8919">
                Unlock Premium Content
              </h3>
            </div>
            <div className="p-4" data-id="element-8920">
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-8921">
                Unlock this exclusive content from Kim Holland for 7 gems. This
                is a one-time purchase.
              </p>
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-8922">
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-2xl" data-id="element-8923">
                  💎
                </div>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-8924">
                <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8925">
                  Your balance:
                </span>
                <span className="font-bold text-gray-900 dark:text-white" data-id="element-8926">
                  15 💎
                </span>
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-8927">
                <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-8928">
                  Cost:
                </span>
                <span className="font-bold text-pink-500 dark:text-pink-400" data-id="element-8929">
                  -7 💎
                </span>
              </div>
              <div className="flex gap-2" data-id="element-8930">
                <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={() => setShowUnlockModal(false)} data-id="element-8931">
                  Cancel
                </button>
                <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={confirmUnlock} data-id="element-8932">
                  Unlock Now
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* Image Generator Modal */}
      {showImageGeneratorModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-8933">
          <div className="relative w-full max-w-lg animate-in zoom-in-90 duration-300 bg-white dark:bg-gray-900 rounded-lg shadow-lg" data-id="element-8934">
            <button className="absolute right-4 top-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" onClick={() => setShowImageGeneratorModal(false)} data-id="element-8935">
              <X size={18} className="text-gray-500 dark:text-gray-400" data-id="element-8936" />
            </button>
            <div className="p-6" data-id="element-8937">
              <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4" data-id="element-8938">
                Generate Image with Kim
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6" data-id="element-8939">
                Create a custom image with Kim. Choose your options and generate
                a unique image.
              </p>
              <div className="space-y-4" data-id="element-8940">
                <div data-id="element-8941">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-8942">
                    Style
                  </label>
                  <input type="text" placeholder="Casual" className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-800" data-id="element-8943" />
                </div>
                <div data-id="element-8944">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-8945">
                    Mood
                  </label>
                  <input type="text" placeholder="Playful" className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-800" data-id="element-8946" />
                </div>
                <div data-id="element-8947">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-8948">
                    Special Request
                  </label>
                  <textarea placeholder="Describe what you'd like to see..." className="w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-800 min-h-[100px]" data-id="element-8949"></textarea>
                </div>
                <div data-id="element-8950">
                  <div className="flex items-center justify-between mb-2" data-id="element-8951">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-8952">
                      Cost:
                    </label>
                    <span className="text-pink-500 font-medium flex items-center gap-1" data-id="element-8953">
                      15 <span className="text-blue-500" data-id="element-8954">💎</span>
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-3" data-id="element-8955">
                    <button className="py-2 px-4 bg-gray-100 dark:bg-gray-800 rounded-md text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={() => setShowImageGeneratorModal(false)} data-id="element-8956">
                      Cancel
                    </button>
                    <button className="py-2 px-4 bg-gradient-to-r from-pink-600 to-purple-600 rounded-md text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => setShowImageGeneratorModal(false)} data-id="element-8957">
                      Generate Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Video Generation Modal */}
      {showVideoUpsellModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-8958">
          <VideoGenerationUpsell onClose={() => setShowVideoUpsellModal(false)} onPurchase={(duration, tokens) => {
        // Handle purchase logic
        setShowVideoUpsellModal(false);
      }} data-id="element-8959" />
        </div>}

      <style jsx data-id="element-8960">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .angel-feed-container {
          max-width: 860px;
          margin: 0 auto;
          padding: 0 16px;
        }
        @media (min-width: 1440px) {
          .angel-feed-container {
            max-width: 1080px;
          }
        }
        .angel-feed-post {
          max-width: 820px;
          margin: 0 auto;
        }
        .angel-post-image {
          width: 100%;
          height: auto;
          object-fit: cover;
          image-rendering: auto;
          border-radius: 0;
        }
        .image-high-quality {
          image-rendering: auto;
        }
      `}</style>
    </section>;
};